import React, { useState } from "react";
import { Button, Input, message, Modal, Select, Spin, Tooltip } from "antd";
import ConsultationService from "../../../Services/ConsultationService";
import medicineImage from "../../../Assets/Images/Svg/addMedicine.svg";
import labReports from "../../../Assets/Images/Svg/addMedicine@.svg";
import MedicineDisabled from "../../../Assets/Images/Svg/MedicineDisabled.svg";
import LabDisabled from "../../../Assets/Images/Svg/LabDisabled.svg";
import PharmacyService from "../../../Services/PharmacyService";
import LabOrderService from "../../../Services/LabOrderService";
import Lab from "../../../Assets/Icons/lab1.svg";
import Med from "../../../Assets/Icons/tablt.svg";
import MedWhite from "../../../Assets/Images/Svg/MedWhite.svg";
import LabWhite from "../../../Assets/Images/Svg/LabWhite.svg";
import ConsentService from "../../../Services/ConsentService";

function ShareOrders({ record, getList }) {
  const [loadingType, setLoadingType] = useState(null);

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [pharAndLabList, setPharAndLabList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sendPayload, setSendPayload] = useState({});
  const [showConsent, setShowConsent] = useState(false);

  const showConsentModal = () => {
    setShowConsent(true);
  };

  const showModal = async () => {
    if (record.shareEpresWithPharmacy === "N") {
      setShowConsent(true);
      return;
    }
    if (
      !record.drugPrescriptionStatus ||
      record.drugPrescriptionStatus === "Decline" ||
      record.drugPrescriptionStatus === ""
    ) {
      setLoadingType("p");
      let medlistpayload = {
        consultationId: record?.consultationId,
        status: 1,
      };
      let druglist = await PharmacyService.GetDispensedDrugsDtl(medlistpayload);
      if (Array.isArray(druglist?.data) && druglist.data.length === 0) {
        message.error("Unable to place order, Medicine List is empty");
        setLoadingType("");
        return;
      }
      let pharmaListPayload = {
        userId: loginResultObject.user.userId,
        status: 1,
      };

      let pharmaList1 = await PharmacyService.GetPharmacyList(
        pharmaListPayload
      );
      setPharAndLabList(pharmaList1.data);
      setIsModalOpen(true);
      setLoadingType(null);
    } else {
      message.error("Medicine Order is Already Placed");
    }
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSelectedItem = (selectedItem) => {
    const selected = pharAndLabList.find(
      (pAndlList) => pAndlList.id === selectedItem
    );
    const filteredList = pharAndLabList.filter(
      (item) => item.id === selectedItem
    );
    setSendPayload(filteredList[0]);
  };

  const [save, setSave] = useState(false);

  const onMedicineOrderSend = async () => {
    setSave(true);
    let LinkPayload = {
      consultationId: record?.consultationId,
      patientId: record.patientId,
      userId: loginResultObject.user.userId,
      appointmentId: record.appointmentId,
      prescriptionShareType: "p",
      vendorId: sendPayload.pharmacyId,
      vendorName: sendPayload.pharmacyName,
      vendorMailId: sendPayload.pharmacyMailId,
      vendorMobile: sendPayload.pharmacyMobile,
      drugPrescriptionStatus: "Sent",
      rejectedPharmacyRemarks: null,
      account_Id: record.account_Id,
      clinic_id: record.clinic_Id,
      sourceChannel: "DOCTOR",
      branchName: sendPayload.pharmacyBranchName,
      branchId: sendPayload.pharmacyBranchId,
    };

    if (record.pharmacyId === LinkPayload.vendorId) {
      message.warning(
        "This pharmacy has already declined your order. Please select another one."
      );
      setSave(false);
      return;
    }

    try {
      const response = await ConsultationService.SharePharmaLabAPI(LinkPayload);

      if (response.data.message !== "Prescription sent successfully") {
        message.error("Medicine order is already placed");
        setLoadingType(null);
        setSave(false);
        return;
      }
      message.success(`Medicine Order Sent to ${LinkPayload.vendorName}`);
      getList();
      setSave(false);
    } catch (error) {
      message.error("Medicine order is already placed");
      setSave(false);
    } finally {
      setLoadingType(null);
      setIsModalOpen(false);
      setSave(false);
    }
  };

  const [labList, setLabList] = useState([]);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [sendPayload2, setSendPayload2] = useState({});

  const showLabModal = async () => {
    if (record.shareEpresWithDiagnostics === "N") {
      setShowConsent(true);
      return;
    }
    if (
      !record.labPrescriptionStatus ||
      record.labPrescriptionStatus === "" ||
      record.labPrescriptionStatus === "Decline"
    ) {
      setLoadingType("l");

      let labListPayload = {
        consultationId: record.consultationId,
        status: 1,
      };

      let labOrderList = await LabOrderService.GetLabTestOrderDtl(
        labListPayload
      );

      if (Array.isArray(labOrderList?.data) && labOrderList.data.length === 0) {
        message.error("Unable to place order, Lab List is empty");
        setLoadingType("");
        return;
      }

      let labList = {
        userId: loginResultObject.user.userId,
        status: 1,
      };

      let labListResult = await LabOrderService.GetLabList(labList);
      setLabList(labListResult.data);
      setIsModalOpen2(true);
      setLoadingType(null);
    } else {
      message.error("Lab Order Already Placed");
    }
  };

  const handleLabCancel = () => {
    setIsModalOpen2(false);
  };

  const handleLabSelect = (selectedItem) => {
    const filteredList = labList.filter((item) => item.id === selectedItem);
    setSendPayload2(filteredList[0]);
  };

  const onLabOrderSend = async () => {
    setSave(true);
    let LinkPayload = {
      consultationId: record?.consultationId,
      patientId: record.patientId,
      userId: loginResultObject.user.userId,
      appointmentId: record.appointmentId,
      prescriptionShareType: "l",
      vendorId: sendPayload2.labId,
      vendorName: sendPayload2.labName,
      vendorMailId: sendPayload2.labMailId,
      vendorMobile: sendPayload2.labMobile,
      labPrescriptionStatus: "Sent",
      rejectedLabRemarks: null,
      account_Id: record.account_Id,
      clinic_id: record.clinic_Id,
      sourceChannel: "DOCTOR",
      branchName: sendPayload2.labBranchName,
      branchId: sendPayload2.labBranchId,
    };
    if (record?.labId === LinkPayload.vendorId) {
      message.warning(
        "This Lab has already declined your order. Please select another one."
      );
      setSave(false);
      return;
    }

    try {
      const response = await ConsultationService.SharePharmaLabAPI(LinkPayload);

      if (response.data.message !== "Prescription sent successfully") {
        message.error("Lab order is already placed");
        getList();
        setIsModalOpen2(false);
        setLoadingType(null);
        setSave(false);
        return;
      }
      message.success(`Lab Order Sent to ${LinkPayload.vendorName}`);
      getList();
      setSave(false);
    } catch (error) {
      message.error("Lab order is already placed");
    } finally {
      setLoadingType(null);
      setIsModalOpen2(false);
      setSave(false);
    }
  };

  const [btnDisable, setBtnDisable] = useState(false);
  const sendRequest = async () => {
    setBtnDisable(true);
    let payload = {
      appointmentId: record.appointmentId,
    };
    try {
      let result = await ConsentService.GetPatientConsent(payload);
      message.success("Request is Send to the patient side");
    } catch (error) {
      message.error("An error occured");
    } finally {
      setShowConsent(false);
      setBtnDisable(false);
    }
  };

  return (
    <>
      {record.transactionId ? (
        <>
          <Tooltip placement="top" title={"Share Medicine Order"}>
            {loadingType === "p" ? (
              <Spin />
            ) : (
              <span
                onClick={showModal}
                className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
              >
                <img src={Med} alt="" />
              </span>
            )}
          </Tooltip>
          <Tooltip placement="top" title={"Share Lab Diagnostics"}>
            {loadingType === "l" ? (
              <Spin />
            ) : (
              <span
                onClick={showLabModal}
                className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
              >
                <img src={Lab} alt="" />
              </span>
            )}
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip
            placement="top"
            title={"Payment is not completed on Patient Side"}
          >
            <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer">
              <img src={MedWhite} alt="" />
            </span>
          </Tooltip>

          <Tooltip
            placement="top"
            title={"Payment is not completed on Patient Side"}
          >
            <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer">
              <img src={LabWhite} alt="" />
            </span>
          </Tooltip>
        </>
      )}
      <Modal
        title="Medicine Order"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div className="flex gap-2">
          <Select
            className="w-[80%]"
            onChange={(selectedItem) => {
              const selectedPharmacy = pharAndLabList.find(
                (pAndlList) => pAndlList.id === selectedItem
              );

              if (selectedPharmacy?.pharmacyId === record.pharmacyId) {
                message.warning(
                  "This pharmacy has already declined your order. Please select another one."
                );
                handleSelectedItem(selectedItem);
                return;
              } else {
                handleSelectedItem(selectedItem);
              }
            }}
          >
            {pharAndLabList?.map((pAndlList) => {
              const isDeclined = pAndlList.pharmacyId === record.pharmacyId;

              return (
                <Select.Option key={pAndlList.id} value={pAndlList.id}>
                  <span
                    style={{
                      color: isDeclined ? "red" : "black",
                      fontWeight: isDeclined ? "bold" : "normal",
                    }}
                  >
                    {pAndlList.pharmacyName}
                  </span>
                </Select.Option>
              );
            })}
          </Select>

          <button
            onClick={onMedicineOrderSend}
            className="p-1 rounded-md bg-brand-primaryColor text-white font-semibold"
            disabled={save}
          >
            Send Order
          </button>
        </div>
      </Modal>

      <Modal
        title="Lab Order"
        open={isModalOpen2}
        onCancel={handleLabCancel}
        footer={[]}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div className="flex gap-2">
          <Select
            className="w-[80%]"
            onChange={(selectedItem) => {
              handleLabSelect(selectedItem);
            }}
          >
            {labList?.map((lab) => (
              <Select.Option key={lab.id} value={lab.id}>
                {lab.labName}
              </Select.Option>
            ))}
          </Select>

          <button
            onClick={onLabOrderSend}
            className="p-1 rounded-md bg-brand-primaryColor text-white font-semibold"
            disabled={save}
          >
            Send Order
          </button>
        </div>
      </Modal>

      <Modal
        title="Get Consent from patient"
        open={showConsent}
        onOk={handleOk}
        onCancel={() => {
          setShowConsent(false);
        }}
        footer={[]}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div className="flex flex-col gap-2">
          <div>
            This patient didn't give consent to share E-prescription , to get
            Consent from patient sent request
          </div>

          <button
            onClick={sendRequest}
            className="p-1 rounded-md bg-brand-primaryColor text-white font-semibold"
            disabled={btnDisable}
          >
            Send Request
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShareOrders;
